import { Component, OnInit } from '@angular/core';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { DashboardService } from '../_services/dashboard.service';

@Component({
  selector: 'app-home',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.css']
})
export class ChangelogComponent implements OnInit {

dashboard:any;


  constructor(private dashboardService:DashboardService) { }

  ngOnInit() {
    this.getDashboard();
  }


  getDashboard(){
    this.dashboardService.getDashboard().subscribe((res:any)=>{
      this.dashboard=res;
    });
  }
 
}
